export default __webpack_public_path__ + "static/media/xls.9a770502.svg";